import { gql } from '@apollo/client';
import { CreateProfileProps } from './profiles.types';
import { CreateProfileType } from '../../../types/Profile.types';
import { PROFILE_DETAIL_FIELDS } from '../../fragments';

const CREATE_PROFILE = gql`
${PROFILE_DETAIL_FIELDS}
  mutation CreateProfile(
    $firstName: String!
    $lastName: String!
    $email: String!
    $phone1: String!
    $password: String!
  ){
    createProfile(
      firstName: $firstName
      lastName: $lastName
      email: $email
      phone1: $phone1
      password: $password
    ){
      ...ProfileDetailsFields
    }
  }
`;

export function createProfile({
  client,
  firstName,
  lastName,
  email,
  phone1,
  password,
}: CreateProfileProps) {
  return client?.mutate<{ createProfile: CreateProfileType }>({
    mutation: CREATE_PROFILE,
    variables: {
      firstName,
      lastName,
      email,
      phone1,
      password,
    },
  });
}
